<div
  *ngIf="fareFamily"
  class="upsell-option relative flex flex--column grow rounded-large overflow-hidden"
  [ngClass]="{ wide: (isMobile$ | async) === true }"
>
  <div>
    <div class="fill ps-xxsmall-x ps-xsmall-y highlight top-bar">
      <div class="font-body-1 bold-type font-body-medium-bold">{{ 'upsellCard.title' | finLocalization }}</div>
    </div>
  </div>
  <div class="pr-xsmall-b ps-xxsmall-l ps-small-r">
    <div class="rounded-large overflow-hidden" *ngIf="imageData$ | async as imageData">
      <div class="relative">
        <fcom-image [imageData]="imageData" [ratio]="enableBenefitChanges === true ? '4x3' : '1x1'" />
        <fcom-tag class="absolute avios-points ms-xsmall-l ms-xsmall-b" *ngIf="isNotAward">
          <fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
          <span *ngIf="fareFamily.totalAviosAccrual">
            {{ 'avios.collectPointsTag' | finLocalization: { points: fareFamily.totalAviosAccrual | finPoints } }}
          </span>
          <span *ngIf="!fareFamily.totalAviosAccrual">
            {{ 'avios.collectUndefinedPoints' | finLocalization }}
          </span>
        </fcom-tag>
      </div>
    </div>
    <div>
      <div class="flex ms-xsmall-t">
        <fcom-icon class="ms-xxsmall-t icon-large" [name]="SvgLibraryIcon.UPGRADE_OUTLINE" />
        <div class="ms-xsmall-l">
          <div class="font-body-1 medium-type font-label-medium">
            {{
              ('travelClass.' + fareFamily.cabinClass.toLowerCase() | finLocalization) ||
                ('travelClass.mixed' | finLocalization)
            }}
          </div>

          <div class="flex flex--middle flex--wrap">
            <span class="font-body-2 flex flex--middle ps-xxsmall-r font-body-small">
              {{ 'pricesStartingFrom' | finLocalization }}
            </span>

            <span *ngIf="fareFamily.originalPrice" class="font-body-2 ps-xsmall-r strike-through font-body-small">
              {{ { amount: fareFamily.originalPrice, currencyCode: currencyCode$ | async } | finPrice }}
            </span>

            <span class="font-heading-5 price font-title-small">
              {{ { amount: fareFamily.price, currencyCode: currencyCode$ | async } | finPrice }}
            </span>
          </div>
        </div>
      </div>
      <span class="font-body-1 ms-xsmall-t font-body-medium">{{ descriptionKey$ | async | finLocalization }}</span>
    </div>
    <fcom-button
      [attr.data-testid]="'cabin-upsell-option-next-class-button'"
      class="ms-xsmall-t"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [mode]="ButtonMode.FILL"
      [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
      [text]="'upsellCard.button' | finLocalization"
      (clickBtn)="selectNextCabinClass.emit(fareFamily)"
    />
    <div class="align-center ms-small-t" *ngIf="(hideCabinClassModalLink$ | async) !== true">
      <a
        [attr.data-testid]="'cabin-upsell-travel-class-differences-link'"
        class="nordic-blue-900-text text-icon-primary font-body-1 bold-type font-body-medium-bold"
        href
        (click)="emitOpenCabinClassModal($event, fareFamily.cabinClass)"
        >{{ 'upsellCard.modalLink.allClasses' | finLocalization }}</a
      >
    </div>
  </div>
</div>
<div
  *ngIf="showCompareBlock$ | async"
  class="upsell-option relative flex flex--column grow rounded-large overflow-hidden ps-xxsmall-l ps-small-r"
>
  <div class="rounded-large overflow-hidden" *ngIf="imageData$ | async as imageData">
    <div class="relative">
      <fcom-image [imageData]="imageData" [ratio]="'1x1'" />
    </div>
  </div>
  <span class="font-body-1 ms-xsmall-t font-body-medium" data-testid="gen-desc">{{
    descriptionKey$ | async | finLocalization
  }}</span>
  <div class="ms-xsmall-t">
    <a
      [attr.data-testid]="'cabin-upsell-travel-class-differences-link'"
      class="nordic-blue-900-text text-icon-primary font-body-1 bold-type font-body-medium-bold"
      href
      (click)="emitOpenCabinClassModal($event, 'Business')"
      >{{ 'upsellCard.modalLink.allClasses' | finLocalization }}</a
    >
  </div>
</div>
